var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiserClapms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1C5 0.447715 5.44772 0 6 0C6.55228 0 7 0.447715 7 1V5H6C3.79086 5 2 6.79086 2 9C2 11.2091 3.79086 13 6 13H7V17C7 17.5523 6.55228 18 6 18C5.44772 18 5 17.5523 5 17V14.917C2.16229 14.441 0 11.973 0 9C0 6.027 2.16229 3.55904 5 3.08296V1ZM14 9C14 6.79086 12.2091 5 10 5H9V1C9 0.447715 9.44771 0 10 0C10.5523 0 11 0.447715 11 1V3.08296C13.8377 3.55904 16 6.027 16 9C16 11.973 13.8377 14.441 11 14.917V17C11 17.5523 10.5523 18 10 18C9.44771 18 9 17.5523 9 17V13H10C12.2091 13 14 11.2091 14 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiserClapms);
export default __webpack_public_path__ + "static/media/riserClapms.ed0781b8.svg";
export { ForwardRef as ReactComponent };